var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"wrap":""}},_vm._l((_vm.selectedAllergens),function(item){
var _obj;
return _c('v-flex',_vm._b({key:item.ID,staticStyle:{"padding":"3px"}},'v-flex',( _obj = {}, _obj[_vm.columnType] = true, _obj ),false),[_c('center',[_c('v-img',{staticStyle:{"height":"auto"},style:({ 'width': _vm.columnType === 'xs2' ? '75%': '100%'}),attrs:{"src":item.Image}})],1)],1)}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }